<template>
  <div
    class="module module-text-block padding_large"
    :class="['bg-' + data.theme]"
  >
    <ModuleHeading v-if="data.text_header" :level="2">{{
      data.text_header
    }}</ModuleHeading>
    <ModuleContainer class="text-columns" :class="classType">
      <DynamicHtml :html="data.text_columns[0].content" />
      <DynamicHtml
        v-if="data.text_columns.length === 2"
        :html="data.text_columns[1].content"
      />
    </ModuleContainer>
  </div>
</template>

<script>
export default {
  name: "text-block",
  props: ["data"],
  computed: {
    classType() {
      return "columns-" + this.data.text_columns.length;
    }
  },
  components: {}
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.module-text-block {
  .module-header {
    //margin-bottom: 0;
  }
  .content-wrapper {
    width: 100%;
  }
  .text-columns {
    display: flex;
    flex-wrap: nowrap;
    &.columns-1 {
      max-width: 60%;
      width: 100%;
      @include mquery(767px) {
        max-width: 100%;
      }
    }
    &.columns-2 {
      .responsive-embed {
        width: 100%;
        height: 100%;
        top: 0;
        position: relative;
        //background: #ccc;
        .inner-holder {
          height: 0;
          position: relative;
          padding-bottom: 56.4%;
          top: 0;
          //transform: translateY(-50%);
          @include mquery(767px) {
            top: auto;
            /*transform: translateY(0); */
            //margin-top: 15px;
          }
        }
      }
      @include mquery(767px) {
        flex-direction: column;
      }
      .html-content {
        max-width: 50%;
        width: 100%;
        @include mquery(767px) {
          max-width: 100%;
        }
        &:first-child {
          margin-top: 0;
          padding-right: 25px;
          @include mquery(767px) {
            padding: 0;
          }
        }
        &:last-child {
          margin-bottom: 0;
          padding-left: 25px;
          @include mquery(767px) {
            padding: 0;
          }
        }
        p {
          &:first-child {
            //margin-top: 0;
          }
          &:last-child {
            //margin-bottom: 0;
            @include mquery(767px) {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    .html-content {
      width: 100%;
    }
  }
}
</style>
